import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Tabs from 'src/components/common/Tabs'
import Mixin from 'src/components/common/Mixin'
import ActionConfirmationModal from '../ActionConfirmationModal'
import VehicleDetails from '../VehicleDetails'
import MakeAndModel from '../MakeAndModel'

const menu = [
  { title: 'Vehicle Details' },
  { title: 'Make & Model' }
]

const VehicleMainContent = ({
  UserVehicleDetails,
  currentTab,
  handlePositionChange,
  instructions,
  vehicleColors: vehicleModelColors,
  vehicleCompatibleSizes,
  vehicleEngineType
}) =>
  <Fragment>
    <CustomTabs
      modal
      menu={ menu }
      position={ currentTab }
      positionHandler={ handlePositionChange }>
      <VehicleDetails
        userVehicleDetails={ UserVehicleDetails }
        vehicleModelColors={ vehicleModelColors }
        vehicleCompatibleSizes={ vehicleCompatibleSizes }
        vehicleEngineType={ vehicleEngineType }
        instructions={ instructions } />
      <MakeAndModel userVehicleDetails={ UserVehicleDetails } instructions={ instructions } />
    </CustomTabs>
    <ActionConfirmationModal />
  </Fragment>


export default VehicleMainContent

VehicleMainContent.propTypes = {
  currentTab: PropTypes.number,
  handlePositionChange: PropTypes.func,
  instructions: PropTypes.string,
  UserVehicleDetails: PropTypes.shape(),
  vehicleColors: PropTypes.arrayOf(PropTypes.shape()),
  vehicleCompatibleSizes: PropTypes.arrayOf(PropTypes.shape()),
  vehicleEngineType: PropTypes.arrayOf(PropTypes.shape())
}

const CustomTabs = styled(Tabs)`
  ${Mixin.responsive('margin', '30px -24px 0', '30px -16px 0')}
`
